/**
 * mutation-types
 */
export const LOGIN_INIT = 'LOGIN_INIT'
export const SET_SYSTEM_MENU = 'SET_SYSTEM_MENU'
export const SET_USER = 'SET_USER'
export const SET_TOKEN = 'SET_TOKEN'
export const LOGIN_OUT = 'LOGIN_OUT'
export const SET_COLLAPSE = 'SET_COLLAPSE'
export const SET_SELECTED_ID = 'SET_SELECTED_ID'
export const SET_TABLE_HEIGHT = 'SET_TABLE_HEIGHT'
export const ADD_VISITED_VIEW = 'ADD_VISITED_VIEW'
export const ADD_CACHED_VIEW = 'ADD_CACHED_VIEW'
export const DEL_VISITED_VIEW = 'DEL_VISITED_VIEW'
export const DEL_CACHED_VIEW = 'DEL_CACHED_VIEW'
export const DEL_OTHERS_VISITED_VIEWS = 'DEL_OTHERS_VISITED_VIEWS'
export const DEL_OTHERS_CACHED_VIEWS = 'DEL_OTHERS_CACHED_VIEWS'
export const DEL_ALL_VISITED_VIEWS = 'DEL_ALL_VISITED_VIEWS'
export const DEL_ALL_CACHED_VIEWS = 'DEL_ALL_CACHED_VIEWS'
export const DEL_OTHERS_VIEWS = 'DEL_OTHERS_VIEWS'
export const ADD_VIEW = 'ADD_VIEW'
export const DEL_VIEW = 'DEL_VIEW'
export const DEL_ALL_VIEWS = 'DEL_ALL_VIEWS'
export const UPDATE_PRINT_STOCK = 'UPDATE_PRINT_STOCK'
export const SET_COUNTRYLIST = 'SET_COUNTRYLIST'

